/* gd-facets: 絞り込みの自動適用とソート送信 */
(function () {
  'use strict';

  function submitFacets(form) {
    if (!form) return;
    /* 空の入力は URL に載せない */
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.type === 'number' && el.value === '') el.disabled = true;
    });
    form.submit();
  }

  function bind() {
    var facets = document.getElementById('gd-facets');
    if (facets && !facets.dataset.gdBound) {
      facets.dataset.gdBound = '1';
      facets.addEventListener('change', function (e) {
        if (e.target.type === 'checkbox') submitFacets(facets);
      });
      facets.querySelectorAll('.gd-facet-apply').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          submitFacets(facets);
        });
      });
      /* 外側クリックで開いているパネルを閉じる */
      document.addEventListener('click', function (e) {
        facets.querySelectorAll('.gd-facet[open]').forEach(function (d) {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        facets.querySelectorAll('.gd-facet[open]').forEach(function (d) { d.removeAttribute('open'); });
      });
    }

    var sortSelect = document.getElementById('gd-sort-by');
    if (sortSelect && !sortSelect.dataset.gdBound) {
      sortSelect.dataset.gdBound = '1';
      sortSelect.addEventListener('change', function () { sortSelect.form.submit(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
